import { Checkbox, Radio, Space } from "antd";
import { Text } from "common/base/Text";
import React from "react";
import styled from "styled-components";
import { BooleanLiteral, IQuestionOption } from "utils/types";

const AnswersSection = styled.div`
  margin-top: 20px;
`;

const AnswersLabel = styled(Text)`
  font-size: 14px;
  color: #666;
  display: block;
  margin-bottom: 12px;
`;

export interface QuizAnswersProps {
    options: IQuestionOption[];
    answerOptionIds: string[];
    updateAnswerOptionIds: (optionIds: string[]) => void;
    allowMultiple?: BooleanLiteral
}

export const QuizAnswers:React.FC<QuizAnswersProps> = ({
    options, allowMultiple, answerOptionIds, updateAnswerOptionIds,
}) => {
    const OptionType = allowMultiple === "true" ? Checkbox : Radio
    return (
        <AnswersSection>
            <AnswersLabel>Answer(s)</AnswersLabel>
            <Space direction="vertical">
            {options?.map((option, optIndex) => {
                return (
                <div key={`answer-${option.id}`}>
                    <OptionType
                        checked={Boolean(answerOptionIds?.includes(option.id))}
                        onChange={(e) => {
                            if(!e.target.checked){
                                const optionIndex = answerOptionIds.indexOf(option.id)
                                answerOptionIds.splice(optionIndex, 1)
                                updateAnswerOptionIds([...answerOptionIds])
                            }else{
                                if(allowMultiple === "true"){
                                    updateAnswerOptionIds([...answerOptionIds, option.id])
                                }else {
                                    updateAnswerOptionIds([option.id])
                                }
                            }
                            
                        }}
                    >
                    Option {optIndex + 1} - {option.text}
                    </OptionType>
                </div>
                )
            })}
            </Space>
        </AnswersSection>
        
    )
}